import React, { useState } from 'react';
import { diagramConfigs, getDiagramRenderer } from './wiring';
import './wiring/WiringDiagram.css';

const WiringDiagram = () => {
    const [currentDiagram, setCurrentDiagram] = useState(0);
    const [connected, setConnected] = useState(new Set());

    const currentConfig = diagramConfigs[currentDiagram];
    const currentWireIds = currentConfig.wireIds || [];

    const toggle = (id) => {
        const next = new Set(connected);
        next.has(id) ? next.delete(id) : next.add(id);
        setConnected(next);
    };

    const progress = currentWireIds.length > 0
        ? Math.round((connected.size / currentWireIds.length) * 100)
        : 0;
    const isOn = (id) => connected.has(id);
    const wcls = (id) => `wire ${isOn(id) ? 'connected' : 'disconnected'}`;

    const reset = () => setConnected(new Set());

    const switchDiagram = (index) => {
        setCurrentDiagram(index);
        setConnected(new Set()); // 切換時重置連接狀態
    };

    // 獲取當前線路圖的渲染函數
    const renderCurrentDiagram = () => {
        if (!currentConfig.isInteractive) {
            // 圖片模式
            return null;
        }
        const renderFunction = getDiagramRenderer(currentDiagram);
        return renderFunction ? renderFunction(wcls, toggle) : null;
    };

    return (
        <div className="wiring-diagram-container">
            <h3>{currentConfig.isInteractive ? '互動式接線圖' : '接線圖'} - {currentConfig.name}</h3>

            {/* 只在互動模式顯示控制面板 */}
            {currentConfig.isInteractive && (
                <div className="diagram-header">
                    <div className="controls">
                        <div className="progress-info">
                            <span>接線進度：{progress}% ({connected.size}/{currentWireIds.length})</span>
                            <div className="progress-bar">
                                <div className="progress-fill" style={{ width: `${progress}%` }} />
                            </div>
                        </div>
                        <button className="reset-btn" onClick={reset}>重置</button>
                    </div>
                </div>
            )}

            {/* 線路圖選擇器 */}
            <div className="diagram-selector">
                <h4>📋 選擇線路圖：</h4>
                <div className="diagram-dropdown-wrapper">
                    <select
                        className="diagram-dropdown"
                        value={currentDiagram}
                        onChange={(e) => switchDiagram(parseInt(e.target.value))}
                    >
                        {diagramConfigs.map((diagram, index) => (
                            <option key={diagram.id} value={index}>
                                {index + 1}. {diagram.name}
                            </option>
                        ))}
                    </select>
                    <div className="dropdown-icon">▼</div>
                </div>
                {currentConfig.description && (
                    <p className="diagram-description">{currentConfig.description}</p>
                )}
            </div>

            <div className="diagram-wrapper">
                {currentConfig.isInteractive ? (
                    // 互動式 SVG 電路圖
                    <svg viewBox="0 0 820 460" className="wiring-svg" xmlns="http://www.w3.org/2000/svg">
                        {renderCurrentDiagram()}
                    </svg>
                ) : (
                    // 靜態圖片
                    <img
                        src={currentConfig.image}
                        alt={currentConfig.name}
                        style={{ width: '100%', maxWidth: '1200px', height: 'auto' }}
                    />
                )}
            </div>

            {/* 只在互動模式顯示說明 */}
            {currentConfig.isInteractive && (
                <div className="instructions">
                    <h4>說明：</h4>
                    <ul>
                        <li>選擇上方下拉選單切換不同的線路圖</li>
                        <li>點擊任意線路來模擬接線；再次點擊可取消</li>
                        <li>已接線會變成紅色，進度條即時更新</li>
                        <li>切換線路圖時會自動重置接線狀態</li>
                    </ul>
                    {progress === 100 && <div className="completion-message">🎉 恭喜！您已完成所有接線！</div>}
                </div>
            )}
        </div>
    );
};

export default WiringDiagram;
